import { IPasswordValidation } from './signup.component';

export const SIGNUP_POINTS = [
  {
    title: 'Compliance & Automation',
    description: 'Ensures regulatory compliance through automated reporting processes, reducing errors.',
  }, {
    title: 'Timely Updates',
    description: 'Keeps abreast of standards changes, ensuring compliance.',
  }, {
    title: 'Data Analytics',
    description: 'Provides tools for insightful financial analysis.',
  }, {
    title: 'Expert support',
    description: 'Offers expert guidance on accounting standards and practices.',
  },
];

export interface IPasswordRequirement {
  text: string;
  validation: string;
  valid: boolean;
}

export const PASSWORD_REQUIREMENTS: IPasswordValidation[] = [
  {
    text: 'At least 8 characters',
    validation: '.{8,}',
    valid: false,
  }, {
    text: 'Cannot contain your name or email address',
    validation: 'NAME_MATCH',
    valid: false,
  }, {
    text: 'Uppercase characters (A - Z)',
    validation: '[A-Z]',
    valid: false,
  }, {
    text: 'Lowercase characters (a - z)',
    validation: '[a-z]',
    valid: false,
  }, {
    text: 'Contains a number and symbol (!, $, #, %, etc.)',
    validation: '(?=.*\\d)(?=.*[!@#$%^&*()_+<>?]).*',
    valid: false,
  },
];

export const PASSWORD_REQUIREMENTS_RESET: IPasswordValidation[] = [
  {
    text: 'At least 8 characters',
    validation: '.{8,}',
    valid: false,
  }, {
    text: 'Uppercase characters (A - Z)',
    validation: '[A-Z]',
    valid: false,
  }, {
    text: 'Lowercase characters (a - z)',
    validation: '[a-z]',
    valid: false,
  }, {
    text: 'Contains a number and symbol (!, $, #, %, etc.)',
    validation: '(?=.*\\d)(?=.*[!@#$%^&*()_+<>?]).*',
    valid: false,
  },
];
